<h1 mat-dialog-title>Bib Record</h1>
<div mat-dialog-content>
  <div class="container-fluid">
    <div class="row">
      <div class="col-12">
        <p [innerHTML]="data"></p>
      </div>
    </div>
  </div>
</div>
<div mat-dialog-actions>
  <button
    role="button"
    type="button"
    aria-label="Yes"
    mat-button
    (click)="saveData()"
    cdkFocusInitial
  >
    Yes
  </button>
  <button role="button" type="button" aria-label="Now" mat-button (click)="dialogRef.close('no')">
    No
  </button>
</div>
